var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _c(
        "el-row",
        { staticClass: "filter" },
        [
          _c(
            "el-col",
            [
              _c(
                "div",
                {
                  staticStyle: {
                    background: "#f3f3f3",
                    height: "30px",
                    "line-height": "30px",
                    padding: "0 25px",
                    display: "flex",
                    "align-items": "center"
                  }
                },
                [
                  _c("div", [_vm._v("筛选查询")]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "auto" },
                      attrs: {
                        type: "text",
                        icon: _vm.filterFold
                          ? "el-icon-arrow-down"
                          : "el-icon-arrow-up"
                      },
                      on: { click: _vm.toggleFilter }
                    },
                    [_vm._v(_vm._s(_vm.filterFold ? "展开筛选" : "收起筛选"))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-collapse-transition", [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.filterFold,
                        expression: "!filterFold"
                      }
                    ]
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { padding: "10px 25px" } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c(
                              "el-form",
                              {
                                staticClass: "demo-form-inline",
                                attrs: { inline: true, model: _vm.form }
                              },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "" } },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          filterable: "",
                                          placeholder: "市场"
                                        },
                                        on: { change: _vm.setChild },
                                        model: {
                                          value: _vm.form.father_market_id,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "father_market_id",
                                              $$v
                                            )
                                          },
                                          expression: "form.father_market_id"
                                        }
                                      },
                                      _vm._l(_vm.market, function(item) {
                                        return _c("el-option", {
                                          key: item.key,
                                          attrs: {
                                            label: item.label,
                                            value: item.key
                                          }
                                        })
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "" } },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          filterable: "",
                                          placeholder: "子市场"
                                        },
                                        model: {
                                          value: _vm.form.market_id,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "market_id", $$v)
                                          },
                                          expression: "form.market_id"
                                        }
                                      },
                                      _vm._l(_vm.child_market, function(item) {
                                        return _c("el-option", {
                                          key: item.key,
                                          attrs: {
                                            label: item.label,
                                            value: item.key
                                          }
                                        })
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c("el-input", {
                                      attrs: { placeholder: "商家名称" },
                                      nativeOn: {
                                        keyup: function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          return _vm.search.apply(
                                            null,
                                            arguments
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.form.supply_name,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "supply_name", $$v)
                                        },
                                        expression: "form.supply_name"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c("el-input", {
                                      attrs: { placeholder: "货号" },
                                      nativeOn: {
                                        keyup: function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          return _vm.search.apply(
                                            null,
                                            arguments
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.form.goods_no,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "goods_no", $$v)
                                        },
                                        expression: "form.goods_no"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c("el-input", {
                                      attrs: { placeholder: "款号" },
                                      nativeOn: {
                                        keyup: function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          return _vm.search.apply(
                                            null,
                                            arguments
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.form.goods_kh,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "goods_kh", $$v)
                                        },
                                        expression: "form.goods_kh"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c("el-input", {
                                      attrs: { placeholder: "SKU编号" },
                                      nativeOn: {
                                        keyup: function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          return _vm.search.apply(
                                            null,
                                            arguments
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.form.sku,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "sku", $$v)
                                        },
                                        expression: "form.sku"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "" } },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          filterable: "",
                                          placeholder: "代采组"
                                        },
                                        model: {
                                          value: _vm.form.pgid,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "pgid", $$v)
                                          },
                                          expression: "form.pgid"
                                        }
                                      },
                                      _vm._l(_vm.pg_list, function(item) {
                                        return _c("el-option", {
                                          key: item.pgid,
                                          attrs: {
                                            label: item.pgname,
                                            value: item.pgid
                                          }
                                        })
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "" } },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          filterable: "",
                                          placeholder: "代采员"
                                        },
                                        model: {
                                          value: _vm.form.pg_member_id,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "pg_member_id",
                                              $$v
                                            )
                                          },
                                          expression: "form.pg_member_id"
                                        }
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: { label: "全部", value: "" }
                                        }),
                                        _vm._v(" "),
                                        _c("el-option", {
                                          attrs: { label: "(空)", value: "0" }
                                        }),
                                        _vm._v(" "),
                                        _vm._l(_vm.memberOption, function(
                                          item
                                        ) {
                                          return _c("el-option", {
                                            key: item.value,
                                            attrs: {
                                              label: item.label,
                                              value: item.value
                                            }
                                          })
                                        })
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "" } },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          filterable: "",
                                          placeholder: "次品组"
                                        },
                                        model: {
                                          value: _vm.form.dgid,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "dgid", $$v)
                                          },
                                          expression: "form.dgid"
                                        }
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: { label: "全部", value: "" }
                                        }),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.defectiveGroupOption,
                                          function(item) {
                                            return _c("el-option", {
                                              key: item.value,
                                              attrs: {
                                                label: item.label,
                                                value: item.value
                                              }
                                            })
                                          }
                                        )
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "" } },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          filterable: "",
                                          placeholder: "次品员"
                                        },
                                        model: {
                                          value: _vm.form.dg_member_id,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "dg_member_id",
                                              $$v
                                            )
                                          },
                                          expression: "form.dg_member_id"
                                        }
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: { label: "全部", value: "" }
                                        }),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.defectiveGroupMemberOption,
                                          function(item) {
                                            return _c("el-option", {
                                              key: item.value,
                                              attrs: {
                                                label: item.label,
                                                value: item.value
                                              }
                                            })
                                          }
                                        )
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "" } },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          filterable: "",
                                          placeholder: "售后退供员"
                                        },
                                        model: {
                                          value: _vm.form.refund_member_id,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "refund_member_id",
                                              $$v
                                            )
                                          },
                                          expression: "form.refund_member_id"
                                        }
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: { label: "全部", value: "" }
                                        }),
                                        _vm._v(" "),
                                        _vm._l(_vm.refundMemberOption, function(
                                          item
                                        ) {
                                          return _c("el-option", {
                                            key: item.value,
                                            attrs: {
                                              label: item.label,
                                              value: item.value
                                            }
                                          })
                                        })
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          multiple: "",
                                          placeholder: "来源"
                                        },
                                        model: {
                                          value: _vm.form.source,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "source", $$v)
                                          },
                                          expression: "form.source"
                                        }
                                      },
                                      _vm._l(_vm.source, function(item) {
                                        return _c("el-option", {
                                          key: item.key,
                                          attrs: {
                                            label: item.label,
                                            value: item.key
                                          }
                                        })
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: { placeholder: "接收状态" },
                                        model: {
                                          value: _vm.form.rd_status,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "rd_status", $$v)
                                          },
                                          expression: "form.rd_status"
                                        }
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: { label: "全部", value: "0" }
                                        }),
                                        _vm._v(" "),
                                        _vm._l(_vm.rd_status, function(item) {
                                          return _c("el-option", {
                                            key: item.key,
                                            attrs: {
                                              label: item.label,
                                              value: item.key
                                            }
                                          })
                                        })
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          placeholder: "不良品类型",
                                          multiple: ""
                                        },
                                        model: {
                                          value: _vm.form.blp_type,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "blp_type", $$v)
                                          },
                                          expression: "form.blp_type"
                                        }
                                      },
                                      _vm._l(_vm.blpTypeOption, function(item) {
                                        return _c("el-option", {
                                          key: item.key,
                                          attrs: {
                                            label: item.label,
                                            value: item.key
                                          }
                                        })
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          placeholder: "出库设备",
                                          multiple: ""
                                        },
                                        model: {
                                          value: _vm.form.out_machine,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "out_machine",
                                              $$v
                                            )
                                          },
                                          expression: "form.out_machine"
                                        }
                                      },
                                      _vm._l(_vm.outMachineOption, function(
                                        item,
                                        key
                                      ) {
                                        return _c("el-option", {
                                          key: key,
                                          attrs: { label: item, value: key }
                                        })
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "出库时间：" } },
                                  [
                                    _c("el-date-picker", {
                                      attrs: {
                                        "default-time": [
                                          "00:00:00",
                                          "23:59:59"
                                        ],
                                        type: "datetimerange",
                                        "value-format": "yyyy-MM-dd HH:mm:ss",
                                        "range-separator": "至",
                                        "start-placeholder": "开始日期",
                                        "end-placeholder": "结束日期"
                                      },
                                      model: {
                                        value: _vm.form.out_time,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "out_time", $$v)
                                        },
                                        expression: "form.out_time"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "次品接收时间：" } },
                                  [
                                    _c("el-date-picker", {
                                      attrs: {
                                        "default-time": [
                                          "00:00:00",
                                          "23:59:59"
                                        ],
                                        type: "datetimerange",
                                        "value-format": "yyyy-MM-dd HH:mm:ss",
                                        "range-separator": "至",
                                        "start-placeholder": "开始日期",
                                        "end-placeholder": "结束日期"
                                      },
                                      model: {
                                        value: _vm.form.rd_time,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "rd_time", $$v)
                                        },
                                        expression: "form.rd_time"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "包裹单号：" } },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        placeholder: "请输入包裹单号",
                                        clearable: ""
                                      },
                                      model: {
                                        value: _vm.form.ex_package_no,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "ex_package_no",
                                            $$v
                                          )
                                        },
                                        expression: "form.ex_package_no"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "primary" },
                                        on: { click: _vm.search }
                                      },
                                      [_vm._v("查询")]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      !_vm.loading
        ? _c(
            "el-row",
            [
              _c(
                "el-col",
                { staticStyle: { border: "1px solid #ddd" } },
                [
                  _c(
                    "el-row",
                    {
                      staticStyle: {
                        background: "#f3f3f3",
                        height: "50px",
                        "line-height": "30px",
                        padding: "0 25px",
                        display: "flex",
                        "align-items": "center"
                      },
                      attrs: { span: 24 }
                    },
                    [
                      _c("el-col", { attrs: { span: 8 } }, [
                        _vm._v("数据列表：")
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        {
                          staticStyle: { "text-align": "right" },
                          attrs: { span: 16 }
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary", size: "mini" },
                              on: { click: _vm.exchangeOutCreateReject }
                            },
                            [_vm._v("退换货接收")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "success", size: "mini" },
                              on: { click: _vm.output }
                            },
                            [_vm._v("\n            导出")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.resData
                    ? _c(
                        "div",
                        { staticStyle: { "margin-bottom": "0" } },
                        [
                          _c(
                            "el-table",
                            {
                              directives: [
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value: _vm.tableLoading,
                                  expression: "tableLoading"
                                }
                              ],
                              ref: "multipleTable",
                              staticStyle: { width: "100%" },
                              attrs: {
                                height: "600",
                                data: _vm.resData.list,
                                "tooltip-effect": "dark"
                              },
                              on: {
                                "selection-change": _vm.handleSelectionChange
                              }
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  type: "selection",
                                  width: "50",
                                  align: "center",
                                  selectable: _vm.checkboxInit
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: { label: "图片", align: "center" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _c("img", {
                                            staticStyle: {
                                              "max-width": "80px",
                                              "max-height": "80px"
                                            },
                                            attrs: {
                                              src: scope.row.middle_img[0],
                                              alt: ""
                                            },
                                            on: {
                                              click: function($event) {
                                                _vm.preview = true
                                                _vm.imgs = scope.row.middle_img
                                              }
                                            }
                                          })
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  4142463669
                                )
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "supply_city",
                                  label: "城市",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "market_name",
                                  label: "市场",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "supply_name",
                                  label: "商家",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "brand_name",
                                  label: "品牌",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "",
                                  label: "商品状态",
                                  align: "center"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                scope.row.goods_lib_goods_status
                                              ) +
                                              "/" +
                                              _vm._s(
                                                scope.row.goods_lib_is_on_sale
                                              ) +
                                              "\n            "
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  4050543588
                                )
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "cat_name",
                                  label: "商品分类",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "goods_name",
                                  label: "商品名称",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "dbid",
                                  label: "打标ID",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "",
                                  label: "货号/颜色/尺码",
                                  align: "center"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(scope.row.goods_no) +
                                              "/" +
                                              _vm._s(scope.row.co_val) +
                                              "/" +
                                              _vm._s(scope.row.si_val) +
                                              "\n            "
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  369571237
                                )
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "sku",
                                  label: "SKU编码",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "source",
                                  label: "来源",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "blp_type",
                                  label: "不良品类型",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "blp_note",
                                  label: "不良品备注",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "pgname",
                                  label: "代采组",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "pgm_admin",
                                  label: "代采员",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "group_name",
                                  label: "次品组",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "dgm_admin",
                                  label: "次品员",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "refund_member_name",
                                  label: "售后退供员",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "out_machine_text",
                                  label: "出库设备",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "out_time",
                                  label: "出库时间",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "out_admin",
                                  label: "出库人",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "operator_time",
                                  label: "打包时间",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "operator_admin_name",
                                  label: "打包人",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "ex_package_no",
                                  label: "包裹单号",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "desk_no",
                                  label: "打包工作台",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "rd_time",
                                  label: "次品接收时间",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "rd_admin",
                                  label: "次品接收人",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "deliver_time",
                                  label: "包裹妥投时间",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "deliver_admin_name",
                                  label: "妥投人",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "deliver_img",
                                  label: "妥投图",
                                  align: "center"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var row = ref.row
                                        return [
                                          row.deliver_img
                                            ? _c("img", {
                                                staticStyle: {
                                                  "max-width": "80px",
                                                  "max-height": "80px"
                                                },
                                                attrs: {
                                                  src: row.deliver_img,
                                                  alt: ""
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.handleViewImages(
                                                      [row.deliver_img]
                                                    )
                                                  }
                                                }
                                              })
                                            : _vm._e()
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  766902943
                                )
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "fevr_supply_signing_time",
                                  label: "商家签收时间",
                                  align: "center"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.resData
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            "text-align": "right",
                            padding: "25px"
                          }
                        },
                        [
                          _c("el-pagination", {
                            attrs: {
                              "current-page": _vm.curPage,
                              background: "",
                              layout: "total, prev, pager, next, jumper ,sizes",
                              total: _vm.resData.count,
                              "page-size": _vm.form.pagesize,
                              "page-sizes": [50, 100, 200, 500]
                            },
                            on: {
                              "update:currentPage": function($event) {
                                _vm.curPage = $event
                              },
                              "update:current-page": function($event) {
                                _vm.curPage = $event
                              },
                              "current-change": _vm.handleCurrentChange,
                              "size-change": _vm.handleSizeChange
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("preview-image", {
        attrs: { show: _vm.preview, imgs: _vm.imgs },
        on: {
          closeBox: function($event) {
            _vm.preview = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ad752060", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ad752060","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/stocking/ExchangeList.vue
// module id = null
// module chunks = 